import {NgModule} from '@angular/core';
import {CareprovidersUnitRoutingModule} from './careproviders-unit-routing.module';
import {CareproviderUnitMainComponentLoaderComponent} from './components/careprovider-unit-main-component-loader/careprovider-unit-main-component-loader.component';
import {CareproviderUnitSchemaService} from './service/careprovider-unit-schema.service';

@NgModule({
  bootstrap: [CareproviderUnitMainComponentLoaderComponent],
  declarations: [CareproviderUnitMainComponentLoaderComponent],
  imports: [CareprovidersUnitRoutingModule],
  providers: [CareproviderUnitSchemaService],
  exports: [],
})
export class CareprovidersUnitModule {}
